var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside-container',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"view-spacing"},[_c('section',[_c('ParticipantLeaderboard',{attrs:{"header":_vm.$t('welcome.globalWinners'),"value":_vm.globalLeader}}),_c('ThankYouCard'),_c('StatisticCards'),_c('StatisticCards',{attrs:{"type":"funFacts"}}),_c('DiscoverMoments')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }